module.exports = __webpack_public_path__ + "images/0fd2472a98c246181cea9aec7a0e3faca46b767e7863210dc6b5dbb24fd170e4.svg";